import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import cn from 'classnames'

import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { Avatar } from '@components/Avatar'
import { CrownIcon } from '@components/icons/CrownIcon'
import { UserAvatarRankProps } from './interface'

export function UserAvatarRank({
  className,
  slug,
  src,
  alt,
  rank,
  width,
  height,
  showSharp = false,
}: UserAvatarRankProps) {
  const modal = useModal({ modal: 'viewAllSponsors' })

  return (
    <Link href={`/profile/${slug}`} prefetch={false}>
      <div
        className='relative cursor-pointer'
        onClick={() => {
          modal.hide()
        }}
      >
        <div
          className={cn('absolute z-10 left-1/2 -translate-x-1/2', {
            'top-[21px]': showSharp,
            'top-[1px]': !showSharp,
          })}
        >
          <div
            className={cn('relative', {
              hidden: rank > 3,
              'text-yellow': rank === 1,
              'text-secondary-1': rank === 2,
              'text-yellow-3': rank === 3,
            })}
          >
            <CrownIcon width='22' height='22' />
            <div className='absolute top-[2px] left-[7px] text-white text-sm font-bold'>
              {rank}
            </div>
          </div>
          <div
            className={cn(
              'bg-gray-4 text-sm font-bold w-[22px] h-[22px] rounded-full flex items-center justify-center text-secondary-1',
              { hidden: rank < 4 || showSharp }
            )}
          >
            {rank}
          </div>
        </div>

        <p
          className={cn(
            'absolute z-10 left-1/2 -translate-x-1/2 font-light font-sarabun text-base text-secondary dark:text-dark-10',
            {
              hidden: rank < 4 || !showSharp,
            }
          )}
        >
          #{rank.toLocaleString()}
        </p>

        <div
          className={cn(className, {
            'mt-[40px]': showSharp,
            'mt-[20px]': !showSharp,
            'border-[3px] border-yellow text-yellow rounded-full': rank === 1,
            'border-[3px] border-secondary-1 text-secondary-1 rounded-full':
              rank === 2,
            'border-[3px] border-yellow-3 text-yellow-3 rounded-full':
              rank === 3,
          })}
        >
          <Avatar className='w-full h-full' src={src} alt='sponsor-avatar' />
        </div>
      </div>
    </Link>
  )
}
